import {
  type DeviceViewEntityId,
  isPacketDetailsEntity,
  isPathlookupDebugEntity,
} from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

export interface SelectEntityTabCommand {
  deviceViewEntityId: DeviceViewEntityId;
  tabId: string;
}

export const selectEntityTab: DeviceViewCommandFactory<SelectEntityTabCommand> =
  (cmdContext) => (command) => {
    let tabIsChanged = false;
    cmdContext.updateState((draft) => {
      const deviceViewEntity = draft.deviceViewEntities.find(
        (entity) => entity.id === command.deviceViewEntityId,
      );
      if (
        deviceViewEntity !== undefined &&
        !isPacketDetailsEntity(deviceViewEntity) &&
        !isPathlookupDebugEntity(deviceViewEntity)
      ) {
        deviceViewEntity.table = command.tabId;
        tabIsChanged = true;
      }
    });

    if (tabIsChanged) {
      cmdContext
        .getState()
        .handlersContainer.handleContentEntityTabChange?.(command);
    }
  };
